import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { makeStyles } from "@material-ui/core/styles";
import style from "./DataObjectBackdrop.module.css";
import { Row, Col } from "react-bootstrap";
import { CircularProgress } from "@material-ui/core";
import SearchDataObjects from "./SearchDataObjects";
import Modal from "@material-ui/core/Modal";
import { GetStateFromData } from "../../CustomHooks/CustomHooks";
import secureLocalStorage from "react-secure-storage";
import secureSessionStorage from "../../../utils/secureSessionStorage";

function DataObjectsBackdrop(props) {
  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      minHeight: "460px",
      minWidth: "752px",
      borderRadius: "2px",
      overflowX: "hidden",
    },
    paper: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
    },
  }));

  const classes = useStyles();
  const contexts = GetStateFromData(props.containerId);
  const { activeApplication } = contexts.contexts;
  const [allProcesses, setAllProcesses] = React.useState([]);
  const [dataObjects, setdataObjects] = React.useState([]);
  const [showLoader, setShowLoader] = React.useState(false);
  const [currentProcess, setCurrentProcess] = React.useState("");
  const [query, setQuery] = React.useState("");
  const [query1, setQuery1] = React.useState("");
  const [dataObjectsPresent, setdataObjectsPresent] = React.useState(false);
  const [mapForSave, setMapForSave] = useState(new Map());

  const launchpadKey=secureSessionStorage.getItem("Authorization") || JSON.parse(secureLocalStorage.getItem("launchpadKey"))?.token;
  var jwtToken = launchpadKey || undefined;

  useEffect(() => {
    if (props.dataObjectType === "Processes") {
      fetch("/mdm-rest/app/getprocesses", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "P",
          sort_order: "A",
          order_by: "0",
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (content) {
          if (content.data.processes !== undefined) {
            setAllProcesses(content.data.processes);
          }
        })
        .catch((err) => {
          console.log("error is", err);
        });
    } else if (props.dataObjectType === "Portals") {
      fetch("/mdm-rest/app/getapplications", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "AP",
          sort_order: "A",
          order_by: "0",
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (content) {
          if (content.data.applications !== undefined) {
            setAllProcesses(content.data.applications);
          }
        })
        .catch((err) => {
          console.log("error is", err);
        });
    } else if (props.dataObjectType === "Categories") {
      fetch("/mdm-rest/app/categories", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "C",
          sort_order: "A",
          order_by: "0",
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (content) {
          if (content.data.categories !== undefined) {
            setAllProcesses(content.data.categories);
          }
        })
        .catch((err) => {
          console.log("error is", err);
        });
    }
  }, []);

  function saveHandler() {
    var saveMap = [];
    const newSaveMap = [];
    const newObj = { do_ids: "" };
    for (var obj of mapForSave.values()) {
      saveMap.push(obj);
    }

    saveMap.forEach((obj) => {
      for (let key in obj) {
        if (key === "do_ids") {
          newSaveMap.push(obj[key]);
        } else {
          newObj[key] = obj[key];
        }
      }
    });
    const d = newSaveMap.join();
    newObj["do_ids"] = d;

    fetch("/mdm-rest/app/setassocinfo", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newObj),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (content) {})
      .catch((err) => {
        console.log("error is", err);
      });
  }

  function checkboxHandler(item) {
    if (mapForSave.has(item.id)) {
      mapForSave.delete(item.id);
    } else {
      var dataObject = {
        do_ids: item.id,
        objectid: currentProcess,
        objecttype:
          props.dataObjectType === "Processes"
            ? "M"
            : props.dataObjectType === "Portals"
            ? "P"
            : "",
        objectname: activeApplication.applicationName,
        multiple: "Y",
      };
      mapForSave.set(item.id, dataObject);
    }
  }

  function selectProcess(item) {
    setShowLoader(true);

    setCurrentProcess(item?.id);

    fetch("/mdm-rest/app/dataobjects", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwtToken,
      },
      body: JSON.stringify({
        parent_id: item?.id,
        type: "C",
        sort_order: "A",
        order_by: "0",
        records_to_fetch: "200",
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (content) {
        if (
          content.data !== undefined &&
          content.data.data_objects !== undefined &&
          content.data.data_objects.length > 0
        ) {
          setShowLoader(false);
          setdataObjects(content.data.data_objects);
          setdataObjectsPresent(false);
        } else {
          setdataObjects([]);
          setShowLoader(false);
          setdataObjectsPresent(true);
        }
      })
      .catch((err) => {
        console.log("error");
      });
  }

  function handleClose() {
    props.handleDataObjectsPopupClose();
  }

  function cancelHandler() {
    props.handleDataObjectsPopupClose();
  }

  return (
    <>
      <Dialog
        className="dataObjectsBackdrop_main"
        open={true}
        classes={{ paper: classes.dialogPaper }}
        onClose={handleClose}
      >
        <Row className={style.backdropHeader}>
          <span className={style.headerClass}>{props.dataObjectType}</span>
        </Row>
        <Row className={style.dialogContent}>
          <div className={style.selectProcess}>Select Processes</div>

          <Row className={style.dataObjectScreen}>
            <Col className={style.dataObjectScreen1}>
              <div className={style.dataObjectSubHeader}>
                <span className={style.dataObjectSubHeaderFont}>
                  Process Names
                </span>
              </div>
              <SearchDataObjects
                width={"200px"}
                collapsedWidth={"200px"}
                setQuery={setQuery}
              />
              <div className={style.processesClass}>
                {allProcesses &&
                  allProcesses
                    .filter((item, index) => {
                      if (query === "") {
                        return item;
                      } else if (
                        item.name.toLowerCase().includes(query.toLowerCase())
                      ) {
                        return item;
                      }
                    })
                    .map((item, index) => (
                      <div key={item.id} className={style.dataObjectSubList}>
                        <input
                          aria-label={"Data Object"}
                          type="radio"
                          name="dataObject"
                          value={item?.name}
                          onChange={() => selectProcess(item)}
                        />
                        &nbsp;&nbsp; &nbsp;&nbsp;
                        {item?.name}
                      </div>
                    ))}
              </div>
            </Col>
            <Col>
              <Modal
                open={showLoader}
                onClose={showLoader ? false : true}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
              >
                {showLoader === true ? (
                  <div className={classes.paper}>
                    <CircularProgress />
                  </div>
                ) : (
                  <div style={{ display: "none" }}></div>
                )}
              </Modal>
            </Col>

            <Col className={style.dataObjectScreen2}>
              <div className={style.dataObjectSubHeader}>
                <span className={style.dataObjectSubHeaderFont}>
                  Data Objects
                </span>
              </div>
              <div>
                <SearchDataObjects
                  width={"200px"}
                  collapsedWidth={"200px"}
                  setQuery={setQuery1}
                />
              </div>
              <div className={style.processesClass}>
                {!showLoader &&
                  dataObjects &&
                  dataObjects
                    .filter((item, index) => {
                      if (query1 === "") {
                        return item;
                      } else if (
                        item.name.toLowerCase().includes(query1.toLowerCase())
                      ) {
                        return item;
                      }
                    })
                    .map((item, index) => (
                      <div key={item.id} className={style.dataObjectSubList}>
                        <input
                          aria-label={"Data Object name"}
                          type="checkbox"
                          onClick={() => checkboxHandler(item)}
                        />
                        &nbsp;&nbsp; &nbsp;&nbsp;
                        {item?.name}
                      </div>
                    ))}
                {dataObjects.length == 0 && dataObjectsPresent === true && (
                  <div style={{ textAlign: "center", marginTop: "15%" }}>
                    <img
                      src={process.env.PUBLIC_URL + "/icons/DataObjects.svg"}
                    />
                    <br />
                    <br />
                    No Data Objects
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Row>
        <Row className={style.backdropFooter}>
          <button
            className={`tertiary ${style.saveDataObjectsButton}`}
            onClick={() => cancelHandler()}
          >
            Cancel
          </button>
          <button
            className={`primary ${style.save2DataObjectsButton}`}
            onClick={() => saveHandler()}
          >
            Save
          </button>
        </Row>
      </Dialog>
    </>
  );
}

export default DataObjectsBackdrop;
